import React, { useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$root/types/components/partials/modules.d.ts').ColumnBlock}
 */
const Column = ({
    heading,
    textCol
}) => {
    const [showAll, setShowAll] = useState(false);

    const maxLength = 20;
    const listLength = textCol?.split('<p')?.length || 0;

    return (
        <div
            className='gap-y-16 grid relative'>
            <div className='w-full flex'>
                <div className='px-layout-col w-1/2 sm:w-1/3'>
                    <p>{heading}</p>
                </div>
            </div>
            <div
                className='w-full relative'
                style={showAll ? {} : {maxHeight: `${22.5 * 10}px`, overflow:'hidden'}}>
                {textCol && (
                    <div
                        className='px-layout-col w-full sm:w-2/3 columns-2 gap-16 column-block'
                        dangerouslySetInnerHTML={{ __html: textCol}}/>
                )}
            </div>
            {(!showAll && (listLength > maxLength)) && (
                <div className='absolute bottom-0 w-full flex'>
                    <div className='w-1/2 sm:w-1/3 px-layout-col'/>
                    <p
                        className='px-layout-col type-style-s pb-8 w-1/3 bg-white cursor-pointer'
                        onClick={() => setShowAll(true)}>
                        {`+${listLength - maxLength} more`}
                    </p>
                </div>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Column;
